import React, { useId } from 'react'
import { cn } from '../../lib/cn'

/**
 * Input con label accesible opcional.
 */
export const Input = React.forwardRef(function Input(
  { label, id, hint, error, className, containerClassName, ...rest },
  ref
) {
  const autoId = useId()
  const inputId = id || autoId
  return (
    <div className={containerClassName}>
      {label && (
        <label htmlFor={inputId} className="label">
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={hint || error ? `${inputId}-desc` : undefined}
        className={cn('input', error && 'border-danger focus:ring-danger/40 focus:border-danger', className)}
        {...rest}
      />
      {(hint || error) && (
        <p id={`${inputId}-desc`} className={cn('mt-1 text-xs', error ? 'text-danger-dark' : 'text-ink-soft')}>
          {error || hint}
        </p>
      )}
    </div>
  )
})

/**
 * Select nativo estilizado con label accesible.
 */
export const Select = React.forwardRef(function Select(
  { label, id, hint, error, className, containerClassName, children, ...rest },
  ref
) {
  const autoId = useId()
  const selectId = id || autoId
  return (
    <div className={containerClassName}>
      {label && (
        <label htmlFor={selectId} className="label">
          {label}
        </label>
      )}
      <select
        ref={ref}
        id={selectId}
        className={cn('input appearance-none pr-9 bg-no-repeat', className)}
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2364748b' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E\")",
          backgroundPosition: 'right 0.65rem center',
          backgroundSize: '1.1rem',
        }}
        {...rest}
      >
        {children}
      </select>
      {(hint || error) && (
        <p className={cn('mt-1 text-xs', error ? 'text-danger-dark' : 'text-ink-soft')}>{error || hint}</p>
      )}
    </div>
  )
})

export default Input
